<div class="content-wrapper">
    <div class="content-header row">

    </div>
    <div class="content-body">

        <div id="user-profile">
            <div class="row">
                <div class="col-12">
                    <div class="card profile-with-cover">
                        <div class="card-img-top img-fluid bg-cover height-300"></div>
                        <div class="media profil-cover-details w-100">
                            <div class="media-left pl-2 pt-2">
                                <a href="#" class="profile-image">
                                    <img src="assets/vendors/images/portrait/small/avatar-s-8.png" class="rounded-circle img-border height-100" alt="Card image">
                                </a>
                            </div>
                            <div class="media-body pt-3 px-2">
                                <div class="row">
                                    <div class="col">
                                        <h3 class="card-title">
                                            {{cuenta.nombres}} {{cuenta.apellidos}}
                                        </h3>
                                    </div>
                                    <div class="col text-right">
                                        <button type="button" class="btn btn-primary d-">
                                            <i class="fa fa-plus"></i>
                                            Seguir
                                        </button>
                                        <div class="btn-group d-none d-md-block float-right ml-2" role="group" aria-label="Basic example">
                                            <button type="button" class="btn btn-success">
                                                <i class="fa fa-dashcube"></i>
                                                Mensaje
                                            </button>
                                            <button type="button" class="btn btn-success">
                                                <i class="fa fa-cog"></i>
                                            </button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <nav class="navbar navbar-light navbar-profile align-self-end">
                            <button class="navbar-toggler d-sm-none" type="button" data-toggle="collapse" aria-expanded="false" aria-label="Toggle navigation"></button>
                            <nav class="navbar navbar-expand-lg">
                                <div class="collapse navbar-collapse" id="navbarSupportedContent">
                                    <ul class="navbar-nav mr-auto">
                                        <li class="nav-item active">
                                            <a class="nav-link" routerLink="time-line">
                                                <i class="fa fa-line-chart"></i>
                                                Linea de Tiempo
                                                <span class="sr-only">(current)</span>
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="empresas">
                                                <i class="fa fa-building-o" aria-hidden="true"></i>
                                                Empresas
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="licencias">
                                                <i class="fa fa-file-pdf-o" aria-hidden="true"></i>
                                                Licencias
                                            </a>
                                        </li>
                                        <li class="nav-item">
                                            <a class="nav-link" routerLink="cambiar-contrasena">
                                                <i class="fa fa-key" aria-hidden="true"></i>
                                                Cambiar Contraseña
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                            </nav>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <router-outlet></router-outlet>

    </div>
</div>